<template>
    <div>
        <b-alert :show="isToShowEmptyListAlert" class="m-0">
            <span>{{ $t('isEmptyAlert') }}</span>
        </b-alert>
        <ObjectiveDetails
            v-on="$listeners"
            v-bind="$attrs"
            v-for="objective in objectives"
            :key="objective.id"
            :objective="objective"
            @onClickNewKeyResult="openNewKeyResultModalCallback"
        />
        <NewKeyResult
            @onCreatedKeyResult="$listeners.onCreatedKeyResult"
            @openModal="openNewKeyResultModalCallback = $event"
        />
    </div>
</template>

<script>
import { ObjectiveDetails } from '../objective/details'
import NewKeyResult from '../key-result/new'

export default {
    name: 'OKRsRaw',
    components: {
        ObjectiveDetails,
        NewKeyResult,
    },
    props: {
        objectives: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            openNewKeyResultModalCallback: () => {},
        }
    },
    computed: {
        isToShowEmptyListAlert() {
            return this.objectives.length === 0
        },
    },
    i18n: {
        messages: {
            'en-US': {
                isEmptyAlert: "You don't have any OKR yet.",
            },
            'es-ES': {
                isEmptyAlert: 'Aún no tienes OKR.',
            },
            'pt-BR': {
                isEmptyAlert: 'Você ainda não possui OKRs.',
            },
        },
    },
}
</script>
